import { create } from 'zustand'

// What the whole console shares that is not the server's data: the offset
// between the browser's clock and the account host's, the confirmations that
// hold the refresh (D-014: a row stays as it is while its question is open),
// and the last announcement for the polite live region.
interface ConsoleStore {
  offset: number
  holds: number
  announcement: { text: string; at: number }
  setServerNow: (iso: string) => void
  hold: () => void
  release: () => void
  announce: (text: string) => void
}

export const useConsole = create<ConsoleStore>((set) => ({
  offset: 0,
  holds: 0,
  announcement: { text: '', at: 0 },
  setServerNow: (iso) => {
    const at = Date.parse(iso)
    if (!Number.isNaN(at)) set({ offset: at - Date.now() })
  },
  hold: () => set((s) => ({ holds: s.holds + 1 })),
  release: () => set((s) => ({ holds: Math.max(0, s.holds - 1) })),
  announce: (text) => set({ announcement: { text, at: Date.now() } }),
}))

/** The account host's time now, from the browser's clock and the last known offset. */
export function serverNow(): number {
  return Date.now() + useConsole.getState().offset
}
